import React, { useEffect, useState } from 'react';

import moment from 'moment';

import Loader from 'Components/Layout/Loader';

import useAPI from 'Hooks/useAPI';
import useTranslation from 'Hooks/useTranslation';
import useRouter from 'Hooks/useRouter';

import { format } from 'date-fns';
import { de } from 'date-fns/locale';
import 'scss/components/placeholder-image.scss';
import 'scss/components/program-page.scss';
import 'scss/components/webonly-agenda.scss';

import 'moment-timezone';

const Agenda = () => {

  const [ agendaTeaserList, setAgendaTeaserList ] = useState(null);

  const API = useAPI();
  const { buildPath } = useRouter();
  const { t } = useTranslation();

  const monthArray = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];

  useEffect(() => {
    if(!agendaTeaserList){
      API.fetchWebOnlyAgenda()
        .then(data => {
          if (data) {
            const keys = Object.keys(data);
            const agendaTeaserList = keys.map(item => ({
              date: ( item == 0 ) ? 0 : `${monthArray[moment(item).month()]} ${moment(item).year()}`,
              teasers: data[item]
            }));
            setAgendaTeaserList(agendaTeaserList);
          }
        });
      }
  }, [ API, monthArray, agendaTeaserList ]);

  const Teaser = (props) => {
    const { image_url, date_start, date_end, genre_name, title, subtitle, text, duration, program_id } = props.data;
    const is_bereits = props.isBereits?? false;
    let date_start_timezone = moment(date_start).tz('Europe/Berlin');
    let date_end_timezone = moment(date_end).tz('Europe/Berlin');

    let from_date = format( new Date( date_start_timezone ), "dd. LLLL", {
      locale: de}
    );
    let from_date_rc = format( new Date( date_start_timezone ), "dd. LLLL yyyy", {
      locale: de}
    );
    let to_date = format( new Date( date_end_timezone ), "dd. LLLL yyyy", {
      locale: de}
    );
    let date = program_id.includes('RC') ? `${t('broadcastAvailableSmall')} ${is_bereits ? t('since') : t('fromDate')} ${from_date_rc}` : `${t('availableOnline')} ${t('availableOnlineFrom')} ${`${from_date}`} ${t('to')} ${`${to_date}`}`;
    let duration_to_min = duration > 0 ? `${Math.floor(duration / 60)} MIN.` : '';
    let has_bar = ( genre_name !== '' && duration_to_min !== '') ? ' | ' : '';
    return(
      <a href={ buildPath('mediathek', { id: program_id })}>
        <div className="teaser" style={{'fontSize':'0'}}>
          <div className="teaser-image">
            <div>
             <img alt={ title } src={image_url} />
            </div>
          </div>
          <div>
            <span className="teaser-date">{date}</span>
            <span className="teaser-genre">{ genre_name } { has_bar } { duration_to_min }</span>
            <div>
                <span className="teaser-title">{ title }</span>
                <span className="teaser-subtitle" style={ subtitle == '' ? { minHeight:'0'} : {}}>{ subtitle }</span>
                <span className="teaser-text" dangerouslySetInnerHTML={{ __html: text}}></span>
            </div>
          </div>
        </div>
      </a>
    )
  };

  if (agendaTeaserList == null) {
    return (
      <Loader />
    );
  }

  return (
    <div id='agenda-page'>
      {agendaTeaserList.length === 0 &&
        <div className="no-results">{t('noResults')}</div>
      }
      {agendaTeaserList.length > 0 &&
        <div className="agenda__title">
          <p><b>{t('webonly.description.title')}</b> {t('webonly.description.text')}</p>
        </div>
      }
      {agendaTeaserList.map((item, index) => {
          if(item.date !== 0){
            return(
              <>

                <div className="month-separator">
                  {t('broadcastAvailableSmall')} {t('fromDate')} {item.date}
                </div>
                <div className="teaser-container">
                  {item.teasers.map((component, index) =>
                    <>
                      <Teaser key={index} data={component}/>
                      <div className="line-separator"></div>
                    </>
                  )}
                </div>
              </>
            )
          }
        }
      )}
      {agendaTeaserList.map((item, index) => {
        if(item.date === 0){
          return(
            <>
              <div className="month-separator bereits" style={{'background':'black','color':'white'}}>
              {t('bereitsOnline')}
              </div>
              <div className="teaser-container">
                {item.teasers.map((component, index) =>
                  <>
                    <Teaser key={index} data={component} isBereits/>
                    <div className="line-separator"></div>
                  </>
                )}
              </div>
            </>
          )
        }
      })}
    </div>
  );
};

export default Agenda;
